export default "/*\n * CSS Rules overrides over tinymce's default styles\n */\n.mce-content-body img {\n  max-width: 100%;\n  height: auto;\n}";